<div class="draw-bar-menu-for-mobile" [ngClass]="{'is-searching': isOpen}">
    <div class="draw-bar-menu-for-mobile__actions" *ngIf="!isOpen">
        <shared-icon-btn *ngIf="(hasScrolled$ | async) && back" icon="back-arrow" size="sm"
            class="draw-bar-menu-for-mobile__btn -for-back" (onClick)="handleBackClick($event)">
        </shared-icon-btn>

        <shared-icon-btn [icon]="toggleIcon" size="sm" class="draw-bar-menu-for-mobile__btn -for-expand"
            (onClick)="handleSearchToggle(!isOpen)">
        </shared-icon-btn>
    </div>

    <ng-container *ngIf="isOpen">
        <shared-search-for-products-filter *ngIf="isOpen && search" (onToggleOpen)="handleSearchToggle($event)"
            [open]="isOpen" class="draw-bar-menu-for-mobile__search">
        </shared-search-for-products-filter>
        <div class="draw-bar-menu-for-mobile__actions" *ngIf="!search">
            <shared-icon-btn [icon]="toggleIcon" size="sm" class="draw-bar-menu-for-mobile__btn -for-expand"
                (onClick)="handleSearchToggle(!isOpen)">
            </shared-icon-btn>
        </div>

        <shared-sub-nav-for-mobile [relativeTarget]="relativeTarget" [scroll]="scroll" [delayScroll]="delayScroll"
            *ngIf="!searchTerm" [activeId]="activeId" (onPageClicked)="handlePageClick($event)" @enterComponent
            [registryId]="registryId" [pages]="pages" class="draw-bar-menu-for-mobile__subnav">
        </shared-sub-nav-for-mobile>
    </ng-container>

</div>